<template>

  <!-- Product Header component displays product information and controls -->
  <product-header
      :product="product"
      :in18="in18"
      :captcha_site_key="captcha_site_key"
      :shipping_in_shop_is_active="shipping_in_shop_is_active"
  />

  <product-info-tabs :product="product" :in18="in18"/>

  <!-- Product reviews -->
  <product-reviews
      :product="product"
      :in18="in18"
  />

  <!-- Recommended Products component shows products recommended for purchase with this product -->
  <recommended-products-manual
      :products="recommended_products"
      :in18="in18"
  />

  <!-- Product Related Manual component determined manually -->
  <products-related-manual
      :products="related_products"
      :in18="in18"
  />

  <!-- Related Products component displays products that were purchased together with this item -->
  <products-related-auto
      :products="related_auto_products"
      :in18="in18"
  />

  <!-- Recently Bought Products component shows products recently purchased by users -->
  <recently-bought-products
      :products="recently_purchased_products"
      :in18="in18"
  />

</template>

<script>

import ProductHeader from "../components/product/ProductHeader.vue";
import ProductInfoTabs from "../components/product/ProductInfoTabs.vue";
import ProductsRelatedAuto from "../components/product/ProductsRelatedAuto.vue";
import RecentlyBoughtProducts from "../components/product/RecentlyBoughtProducts.vue";
import RecommendedProductsManual from "../components/product/RecommendedProductsManual.vue";
import ProductRelatedManual from "../components/product/ProductRelatedManual.vue";
import AutoSlider from "../components/sliders/AutoSlider.vue";
import ProductReviews from "../components/product/ProductReviews.vue";

export default {
  name: "Product",

  components: {
    'auto-slider':                 AutoSlider,
    'product-header':              ProductHeader,
    'product-info-tabs':           ProductInfoTabs,
    'products-related-manual':     ProductRelatedManual,
    'products-related-auto':       ProductsRelatedAuto,
    'recently-bought-products':    RecentlyBoughtProducts,
    'recommended-products-manual': RecommendedProductsManual,
    'product-reviews':             ProductReviews,
  },

  props: {
    product:                     Object,  // The product object to display
    in18:                        Object,  // Internationalization object for language support
    shipping_in_shop_is_active:  Boolean,
    captcha_site_key:            String,
    related_products:            Object,
    recommended_products:        Object,
    related_auto_products:       Object,
    recently_purchased_products: Object,
  },
}
</script>